import Vue from "vue";
// import store from "@/store";
import { cache } from "@/utils/common";

// import store from '@/store'

!Vue.prototype.$auth &&
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get() {
        return permissions => {
          const user = cache.get("userInfo");
          const wxUser = cache.get("wxUser");
          let userInfo = "";
          if (user && user.Permissions) {
            userInfo = user;
          } else if (wxUser && wxUser.Permissions) {
            userInfo = wxUser;
          }

          const userPermissions = userInfo && userInfo.Permissions;
          if (userPermissions && userPermissions.length) {
            return userPermissions.includes(permissions);
          }
        };
      }
    }
  });
